import script from "./app.vue?vue&type=script&setup=props&lang=js"
export * from "./app.vue?vue&type=script&setup=props&lang=js"

const __exports__ = script;

export default __exports__